// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"112":"63531c882ce49f575cb8","311":"7c69f7a7064bdce547e3","344":"b1e1729ee7319dd5bb6a"}[chunkId] + ".chunk.min.js";
};